import {Typography} from '@bonprix/design-system';
import {SearchResultItem} from './SearchResultItem.jsx';
import React from 'react';
import useSearchTexts from '../hooks/use-search-texts.js';

export const SearchDropdown = ({
    listMode,
    currentList,
    deferredSearchTerm,
    selectedIndex,
    selectionMode,
    handleSelectItem,
    handleSearchResultItemHover,
    unselectField,
    clearSearchHistory,
}) => {
    const {data: searchTextsData} = useSearchTexts();
    const HISTORY_LIST_MODE = 'HISTORY';

    return (
        <div
            className={`search__input-dropdown xl:border-solid xl:border xl:border-clr-on-primary-low`}
            onMouseLeave={unselectField}
            onMouseDown={(e) => {
                e.preventDefault();
            }}
        >
            {listMode === HISTORY_LIST_MODE && (
                <div className="search__input__dropdown-header">
                    <Typography variant="bonprix-h5" component={'span'}>
                        {searchTextsData?.searchHistoryHeader}
                    </Typography>
                    <button className={'search__input__dropdown__clear__history-button'} onClick={clearSearchHistory}>
                        {searchTextsData?.clearSearchHistory}
                    </button>
                </div>
            )}
            <ul
                className={'search__input__dropdown-list'}
                role="listbox"
                id="search-suggestions-listbox"
                aria-label={searchTextsData?.searchHistoryHeader}
            >
                {currentList.map((item, index) => (
                    <SearchResultItem
                        key={index}
                        searchTerm={deferredSearchTerm}
                        value={item}
                        listMode={listMode}
                        isActive={index === selectedIndex}
                        selectionMode={selectionMode}
                        onSelect={handleSelectItem}
                        id={`search-option-${index}`}
                        onMouseOver={() => {
                            handleSearchResultItemHover(index);
                        }}
                    />
                ))}
            </ul>
        </div>
    );
};
